export class RequestType {
    static LINE = "Line";
    static TICKET = "Ticket";
}
